/* eslint-disable no-param-reassign */
import axios from "axios";

const http = axios.create({
  baseURL: "https://backend-template.qisqa.link/api",
});

http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

http.interceptors.response.use(
  (config) => {
    return config;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.clear();
    }

    throw error;
  },
);

export default http;

export const endpoints = {
  auth: {
    // profile
    me: "/auth/me",
    // sign-up-with-phone-number
    verify_phone_otp: "/auth/verify-phone-otp",
    send_otp_code: "/auth/otp/phone",
    sign_up_phone: "/auth/signup-phone",
    sign_in_phone: "/auth/signin-phone",
    // sign-in-with-email
    sign_in_with_email: "/auth/signin-email",
    sign_up_with_email: "/auth/signup-email",
    // sign-in-with-google
    sign_in_with_google: "/auth/google/callback",
    // logout
    logout: "/auth/logout/",
    // refresh-token
    refresh: "/auth/refresh",
  },
};
